import React, { DetailedHTMLProps, FunctionComponent, InputHTMLAttributes } from 'react';

import './ShoppingPlannerInput.scss';

export const ShoppingPlannerInput: FunctionComponent<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & { label: string; grey?: boolean }
> = (props) => {
    // make sure only valid props are spread to ``input`` element
    const { grey, ...inputProps } = props;

    return (
        <div
            className={[
                'shopping-planner-input',
                grey ? 'shopping-planner-input--grey' : '',
                props.disabled ? 'shopping-planner-input--disabled' : '',
            ].join(' ')}
        >
            <input {...inputProps} />
            <label>{props.label}</label>
        </div>
    );
};
